/*
 * @Author: Gaho
 * @Date: 2023-12-29 16:29:22
 * @LastEditors: Gaho
 * @LastEditTime: 2024-09-06 17:57:36
 */
const checkValue = (weakMap) => (key, value) => {
    weakMap.set(key, value);
    return value;
};
const limit = Number.MAX_SAFE_INTEGER || 9007199254740991; // 精确表示的最大整数
const threshold = 536870912;
const range = threshold * 2;
const generateUniqueNumber = (setWeakMap, cache) => collection => {
    const weakKey = cache.get(collection);
    let uniqueNumber;

    // 计算初始 uniqueNumber
    if (weakKey === undefined) {
        uniqueNumber = collection.size;
    } else {
        uniqueNumber = weakKey < range ? weakKey + 1 : 0;
    }

    // 检查 uniqueNumber 是否唯一
    if (!collection.has(uniqueNumber)) {
        return setWeakMap(collection, uniqueNumber);
    }

    // 如果集合的大小小于阈值，生成随机数
    if (collection.size < threshold) {
        do {
            uniqueNumber = Math.floor(Math.random() * range);
        } while (collection.has(uniqueNumber));

        return setWeakMap(collection, uniqueNumber);
    }

    // 如果集合的大小超过限制，抛出错误
    if (collection.size >= limit) {
        throw new Error("Congratulations, you created a collection of unique numbers which uses all available integers!");
    }

    // 继续生成唯一数直到找到一个未被使用的
    do {
        uniqueNumber = Math.floor(Math.random() * limit);
    } while (collection.has(uniqueNumber));

    return setWeakMap(collection, uniqueNumber);
};
let weakMap = new WeakMap();
let setWeakMap = checkValue(weakMap);
let getUniqueId = generateUniqueNumber(setWeakMap, weakMap);

const isCall = (event) => {
    // 判断事件对象的 `method` 属性是否存在且值为 `call`
    return event.method === "call";
};

const messageVerify = (message) => {
    // 验证消息是否有效
    return message.error === null && typeof message.id === "number";
};
const immediateScript = (data) => {
    const oMap = new Map([[0, () => {}]]);
    const eMap = new Map([[0, () => {}]]);
    const aMap = new Map();
    const newWorker = new Worker(data);

    newWorker.addEventListener("message", ({ data }) => {
        if (isCall(data)) {
            const { params: { timerId, timerType } } = data;
            const currentVal = timerType === "interval" ? oMap.get(timerId) : eMap.get(timerId);

            if (typeof currentVal === "number") {
                const m = aMap.get(currentVal);
                if (!m || m.timerId !== timerId || m.timerType !== timerType) {
                    throw new Error("The timer is in an undefined state.");
                }
            } else if (typeof currentVal === "function") {
                currentVal();
                if (timerType === "timeout") eMap.delete(timerId);
            } else {
                throw new Error("The timer is in an undefined state.");
            }
        } else if (messageVerify(data)) {
            const { id } = data;
            const i = aMap.get(id);
            if (!i) throw new Error("The timer is in an undefined state.");

            aMap.delete(id);
            (i.timerType === "interval" ? oMap : eMap).delete(i.timerId);
        } else {
            throw new Error(data.error.message);
        }
    });

    return {
        clearInterval: (timerId) => {
            const uniqueId = getUniqueId(aMap);
            aMap.set(uniqueId, { timerId, timerType: "interval" });
            oMap.set(timerId, uniqueId);
            newWorker.postMessage({
                id: uniqueId,
                method: "clear",
                params: { timerId, timerType: "interval" },
            });
        },
        clearTimeout: (timerId) => {
            const uniqueId = getUniqueId(aMap);
            aMap.set(uniqueId, { timerId, timerType: "timeout" });
            eMap.set(timerId, uniqueId);
            newWorker.postMessage({
                id: uniqueId,
                method: "clear",
                params: { timerId, timerType: "timeout" },
            });
        },
        setInterval: (func, delay) => {
            const uniqueId = getUniqueId(oMap);
            oMap.set(uniqueId, () => {
                func();
                if (typeof oMap.get(uniqueId) === "function") {
                    newWorker.postMessage({
                        id: null,
                        method: "set",
                        params: {
                            delay,
                            now: performance.now(),
                            timerId: uniqueId,
                            timerType: "interval",
                        },
                    });
                }
            });
            newWorker.postMessage({
                id: null,
                method: "set",
                params: {
                    delay,
                    now: performance.now(),
                    timerId: uniqueId,
                    timerType: "interval",
                },
            });
            return uniqueId;
        },
        setTimeout: (func, delay) => {
            const uniqueId = getUniqueId(eMap);
            eMap.set(uniqueId, func);
            newWorker.postMessage({
                id: null,
                method: "set",
                params: {
                    delay,
                    now: performance.now(),
                    timerId: uniqueId,
                    timerType: "timeout",
                },
            });
            return uniqueId;
        },
    };
};
/**
 * 加载脚本
 * @param {*} callback 
 * @param {*} script 
 * @returns 
 */
const loadScript = (callback, script) => {
    let scriptObject = null;

    return () => {
        // 如果脚本已经加载，则直接返回
        if (scriptObject !== null) {
            return scriptObject;
        }

        const blob = new Blob([script], { type: "application/javascript; charset=utf-8" });
        const url = URL.createObjectURL(blob);

        // 加载脚本并调用回调
        scriptObject = callback(url);

        // 释放 URL 对象
        setTimeout(() => URL.revokeObjectURL(url), 0);

        return scriptObject;
    };
};

const iImmediate = `(()=>{"use strict";const e=new Map,t=new Map,r=(e,t)=>{let r,o;const i=performance.now();r=i,o=e-Math.max(0,i-t);return{expected:r+o,remainingDelay:o}},o=(e,t,r,i)=>{const s=performance.now();s>r?postMessage({id:null,method:"call",params:{timerId:t,timerType:i}}):e.set(t,setTimeout(o,r-s,e,t,r,i))};addEventListener("message",(i=>{let{data:s}=i;try{if("clear"===s.method){const{id:r,params:{timerId:o,timerType:i}}=s;if("interval"===i)(t=>{const r=e.get(t);if(undefined===r)throw new Error('There is no interval scheduled with the given id "'.concat(t,'".'));clearTimeout(r),e.delete(t)})(o),postMessage({error:null,id:r});else{if("timeout"!==i)throw new Error('The given type "'.concat(i,'" is not supported'));(e=>{const r=t.get(e);if(undefined===r)throw new Error('There is no timeout scheduled with the given id "'.concat(e,'".'));clearTimeout(r),t.delete(e)})(o),postMessage({error:null,id:r})}}else{if("set"!==s.method)throw new Error('The given method "'.concat(s.method,'" is not supported'));{const{params:{delay:i,now:n,timerId:a,timerType:d}}=s;if("interval"===d)((t,i,s)=>{const{expected:n,remainingDelay:a}=r(t,s);e.set(i,setTimeout(o,a,e,i,n,"interval"))})(i,a,n);else{if("timeout"!==d)throw new Error('The given type "'.concat(d,'" is not supported'));((e,i,s)=>{const{expected:n,remainingDelay:a}=r(e,s);t.set(i,setTimeout(o,a,t,i,n,"timeout"))})(i,a,n)}}}}catch(e){postMessage({error:{message:e.message},id:s.id,result:null})}}))})();`
const immediate = loadScript(immediateScript, iImmediate);
const handleClearInterval = timer => immediate().clearInterval(timer);
const handleClearTimeout = timer => immediate().clearTimeout(timer);
const handleSetInterval = (timer, time) => immediate().setInterval(timer, time);
const handleSetTimeout = (timer, time) => immediate().setTimeout(timer, time);

/**
 * 乘法函数，用来得到精确的乘法结果
 * @param {number} arg1 
 * @param {number} arg2 
 * @returns arg1乘以 arg2的精确结果
 */
const accMultiple = function (arg1, arg2) {
    let len = 0,
        stringArg1 = arg1.toString(),
        stringArg2 = arg2.toString();
    try {
        len += stringArg1.split(".")[1].length;
    } catch (e) { }
    try {
        len += stringArg2.split(".")[1].length;
    } catch (e) { }
    return Number(stringArg1.replace(".", "")) * Number(stringArg2.replace(".", "")) / Math.pow(10, len);
};
/**
 * 减法函数，用来得到精确的减法结果
 * 说明：javascript的减法结果会有误差，在两个浮点数相减的时候会比较明显。这个函数返回较为精确的减法结果。
 * 调用：accSub(arg1,arg2)
 * 返回值：arg1加上arg2的精确结果
*/
const accSub = (arg1, arg2) => {
    var len1, len2, m, n;
    try {
        len1 = arg1.toString().split(".")[1].length;
    } catch (e) {
        len1 = 0;
    }
    try {
        len2 = arg2.toString().split(".")[1].length;
    } catch (e) {
        len2 = 0;
    }
    m = Math.pow(10, Math.max(len1, len2)); //动态控制精度长度
    n = (len1 >= len2) ? len1 : len2;
    return ((arg1 * m - arg2 * m) / m).toFixed(n);
}
/**
** 加法函数，用来得到精确的加法结果
** 说明：javascript的加法结果会有误差，在两个浮点数相加的时候会比较明显。这个函数返回较为精确的加法结果。
** 调用：accAdd(arg1,arg2)
** 返回值：arg1加上arg2的精确结果
*/
const accAdd = (arg1, arg2) => {
    var len1, len2, m, c;
    try {
        len1 = arg1.toString().split(".")[1].length;
    } catch (e) {
        len1 = 0;
    }
    try {
        len2 = arg2.toString().split(".")[1].length;
    } catch (e) {
        len2 = 0;
    }
    c = Math.abs(len1 - len2);
    m = Math.pow(10, Math.max(len1, len2));
    if (c > 0) {
        var cm = Math.pow(10, c);
        if (len1 > len2) {
            arg1 = Number(arg1.toString().replace(".", ""));
            arg2 = Number(arg2.toString().replace(".", "")) * cm;
        } else {
            arg1 = Number(arg1.toString().replace(".", "")) * cm;
            arg2 = Number(arg2.toString().replace(".", ""));
        }
    } else {
        arg1 = Number(arg1.toString().replace(".", ""));
        arg2 = Number(arg2.toString().replace(".", ""));
    }
    return (arg1 + arg2) / m;
}

export {
    handleSetInterval,
    handleClearInterval,
    handleClearTimeout,
    handleSetTimeout,
    accMultiple,
    accSub,
    accAdd
};
